const initialState = {
  RelayState: '',
  SAMLResponse: '',
  connect_user_provisioned: undefined,
  destination_url: '',
  username: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IFRAME':
      return { ...state, ...action.data };
    case 'CLEAR_IFRAME':
      return { ...initialState };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
